import _ from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import config from '@/configs/config';
import { useECSettingsContext } from '../../contexts/ecSettings';

const NavMenuWrapper = styled.div`
  color: black;
  position: relative;
  user-select: none;
  height: 50px;
  &:after {
    background-color: #666;
    position: absolute;
    content: '';
    top: 0;
    left: calc(50% - 50vw);
    width: 100vw;
    height: 50px;
    z-index: -1;
  }
`;

const NavMenuBackground = styled.div`
  position: absolute;
  width: 100%;
  &:before {
    background-color: #AAA;
    position: absolute;
    content: '';
    top: 50px;
    left: calc(-50vw + 50%);
    width: 100vw;
    height: calc(100% - 50px);
    z-index: 1;
  }
`;

const NavMenuContainer = styled.div`
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: visible;
  position: relative;
  width: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar { 
      display: none;
  }
`;

const NavMenu = styled.div`
  display: inline-block;
  vertical-align: top;
  color: white;
  & span{
    display: none;
  }
  &:focus, &:focus-within{
    outline: none;
    color: black;
    & span{
        display: block;
    }
  }
`;

const NavMenuTitle = styled.div`
  padding: 0px 50px 0px 10px;
  cursor: pointer;
  position: relative;
  height: 50px;
  line-height: 50px;
`;

const Triangle = styled.div`
  width: 0; 
  height: 0; 
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 10px solid;
  margin-left: 5px;
  display: inline-block !important;
`;

const NavChildContainer = styled.span`
  position: relative;
  top: 100%;
  padding: 10px;
  color: black;
  z-index: 999;
  &:before {
    content: '';
    position: absolute;
    height: calc(100% - 20px);
    width: 2px;
    margin-left: -10px;
    background-color: black;
  }
`;

const NavChildCore = styled.a`
  display: block;
  color: black;
  cursor: pointer;
  &:hover{
    opacity: 0.5;
  }
`;

const HomepageNotifications = styled.div`
  background-color: ${config.themeBackgroundColor};
  color: white;
  position: relative;
  text-align: center;
  padding: 5px;
  cursor: default;
  &:before {
    background-color: ${config.themeBackgroundColor};
    position: absolute;
    content: '';
    top: 0;
    left: calc(50% - 50vw);
    width: 100vw;
    height: 100%;
    z-index: -1;
  }
`;

const NavChild = ({ url, ...props }) => {
  const history = useHistory();
  const origin = _.get(window, ['location', 'origin'], '');
  const handleClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.blur();
    if ((url || '').startsWith(origin)) {
      history.push(url.replace(origin, ''));
    } else {
      window.location.href = url;
    }
  }, [url, origin, history]);
  return (
    <NavChildCore
      onClick={handleClick}
      {...props}
      href={url}
    />
  );
};

export default () => {
  const { ecSettings } = useECSettingsContext();

  const navMenu = useMemo(() => _.get(ecSettings, ['NAV_MENU'], []), [ecSettings]);
  const notifications = useMemo(() => _.get(ecSettings, ['NOTIFICATION'], []), [ecSettings]);

  return [
    navMenu && navMenu.length > 0 && (
      <NavMenuWrapper key="0">
        <NavMenuBackground>
          <NavMenuContainer>
            {
              navMenu.map(({ name, children }) => {
                try {
                  return (
                    <NavMenu key={name} tabIndex={0}>
                      <NavMenuTitle>
                        {name}
                        <Triangle />
                      </NavMenuTitle>
                      <NavChildContainer>
                        {(children || []).map(({ name: childName, url }) => (
                          <NavChild key={`${childName}_${url}`} url={url}>
                            {childName}
                          </NavChild>
                        ))}
                      </NavChildContainer>
                    </NavMenu>
                  );
                } catch (error) {
                  console.error(error);
                }
                return null;
              })
            }
          </NavMenuContainer>
        </NavMenuBackground>
      </NavMenuWrapper>
    ),
    notifications && notifications.length > 0 && notifications.map((notification) => (
      <HomepageNotifications key={notification}>
        {notification}
      </HomepageNotifications>
    )),
  ];
};
